module.exports = __webpack_public_path__ + "img/sc_s.960a7941.png";